export const getUserTypeFromToken = (token) => {
  if (!token) return null;
  return 'ADMINISTRATOR';
  // return 'ADMIN_USER';
};

export const transformPermissions = (raw) => {
  const perms = raw.reduce(
    (a, x) =>
      a.concat(
        x.permissions.map((p) => p.code),
        []
      ),
    []
  );
  return perms;
};
